import type { DynamoDbCarDetails } from '@ourbranch/schema-types/dynamodb';

import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState, formatCarData } from './lib/helpers';

export const carWithBusinessUse = defineInternalTask({
  taskName: internalTasks.CarWithBusinessUse,
  config: {
    staffDisplayName: 'Car with Business Usage: review needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['A'],
    enabled: true,
    trigger: ({ policy, offer }) => {
      const cars = (offer?.quote?.cars || []).filter((c): c is DynamoDbCarDetails => !!c);
      const businessCars = cars.filter((car) => car.primaryUse === 'B');
      if (businessCars.length === 0) {
        return null;
      }
      return {
        data: { carsData: formatCarData(businessCars) },
        bindState: baseBindState(policy)
      };
    },
    description: ({ policyId, data }) =>
      `The following car(s) on ${policyId} were bound with Business usage:
${data.carsData || 'N/A'}`
  }
});
